/* NUTRIO kedvencek (wishlist). Fred 2026-10-16: "2: legyen" -- saved to the customer's account.
 *
 * Guests: the list lives in localStorage on this device.
 * Logged-in customers: the list lives in the customer metafield custom.kedvencek, written through
 * Kevin's app proxy (POST /apps/kedvencek, full list, Shopify signs the request). The theme reads the
 * metafield in Liquid (window.NutrioKedvencek.server). On first login the guest list is merged in.
 * If the proxy is not reachable (app not installed yet, network), the change is kept locally as an
 * operation log and retried on the next page load, so nothing is lost and nothing breaks.
 */
(function () {
  'use strict';
  var cfg = window.NutrioKedvencek || {};
  var GUEST_KEY = 'nutrio_kedvencek_v1';
  var CUST_KEY = cfg.customerId ? 'nutrio_kedvencek_c' + cfg.customerId : null;
  var MAX = 100;
  // After a successful write the Liquid metafield may lag a page load behind; trust our own
  // write for this long instead of the (possibly stale) server copy.
  var FRESH_MS = 10 * 60 * 1000;

  function read(key) {
    try { return JSON.parse(localStorage.getItem(key)); } catch (e) { return null; }
  }
  function write(key, val) {
    try { if (val === null) localStorage.removeItem(key); else localStorage.setItem(key, JSON.stringify(val)); return true; } catch (e) { return false; /* private mode, quota */ }
  }
  // De-duplicate; no length cap here, so nothing is dropped silently (the cap is enforced on add).
  function clean(arr) {
    var seen = {}, out = [];
    (Array.isArray(arr) ? arr : []).forEach(function (x) {
      if (!x || !x.id || seen[x.id]) return;
      seen[x.id] = 1;
      out.push({ id: Number(x.id), handle: String(x.handle || '') });
    });
    return out;
  }

  // Logged-in sync (Kevin's app proxy, 2026-10-16): GET -> {ids, version}; POST {ids, base_version}
  // -> {version}, or 409 {ids, version} when another device saved in between. Local changes are kept
  // as an operation log (add/remove), so on a conflict they are replayed onto the fresh server list
  // instead of overwriting it.
  var list = [];
  var cust = null;   // {items, ops:[{t:'+'|'-', id, handle}], version, ts}
  var known = {};    // product id -> handle, for ids that come back from the server without one

  function remember(arr) { arr.forEach(function (x) { if (x.handle) known[x.id] = x.handle; }); }
  function fromIds(ids) {
    return clean((ids || []).map(function (g) {
      var id = Number(String(g).split('/').pop());
      return { id: id, handle: known[id] || '' };
    }));
  }
  function replay(base, ops) {
    var out = base.slice();
    ops.forEach(function (o) {
      out = out.filter(function (x) { return x.id !== o.id; });
      if (o.t === '+') out.unshift({ id: o.id, handle: o.handle || known[o.id] || '' });
    });
    return out.slice(0, MAX);
  }
  function saveCust() { return write(CUST_KEY, cust); }

  function load() {
    if (cfg.loggedIn && CUST_KEY) {
      remember(clean(cfg.server));
      cust = read(CUST_KEY);
      if (!cust || !Array.isArray(cust.ops)) cust = { items: null, ops: [], version: undefined, ts: 0 };
      remember(clean(cust.items));
      var fresh = (Date.now() - (cust.ts || 0)) < FRESH_MS;
      // Pending changes are replayed on the server copy; a just-written list beats a lagging metafield.
      list = cust.ops.length ? replay(clean(cfg.server), cust.ops) : clean(fresh && cust.items ? cust.items : cfg.server);
      var guest = clean(read(GUEST_KEY));
      if (guest.length) {
        remember(guest);
        var room = MAX - list.length, rest = [], added = [];
        guest.forEach(function (g) {
          if (has(g.id)) return;
          if (room > 0) { added.push({ t: '+', id: g.id, handle: g.handle }); room--; } else rest.push(g);
        });
        cust.ops = cust.ops.concat(added);
        list = replay(list, added);
        cust.items = list;
        // Only drop the guest copy once the merged list is safely stored.
        if (saveCust()) write(GUEST_KEY, rest.length ? rest : null);
      }
      if (cust.ops.length) push();
    } else {
      list = clean(read(GUEST_KEY));
    }
  }

  function has(id) { id = Number(id); return list.some(function (x) { return x.id === id; }); }
  load();

  function persist(op) {
    if (cfg.loggedIn && CUST_KEY) {
      if (op) cust.ops.push(op);
      cust.items = list; cust.ts = Date.now();
      saveCust();
      push();
    } else {
      write(GUEST_KEY, list);
    }
  }

  // One request at a time; a change made during a request is sent right after it.
  var pushTimer = null, inFlight = false, again = false;
  function push() {
    clearTimeout(pushTimer);
    pushTimer = setTimeout(send, 400);
  }
  function api(method, body) {
    return fetch(cfg.proxy || '/apps/kedvencek', {
      method: method, credentials: 'same-origin', cache: 'no-store',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) { j.status = r.status; return j; });
    });
  }
  function adopt(j) {   // server state + our pending ops
    // items: [{id: "gid://shopify/Product/123", handle}] (Kevin 2026-10-16). The order and membership
    // come from ids; items only supplies handles (a deleted product may have an id but no item).
    if (Array.isArray(j.items)) remember(j.items.map(function (x) {
      return { id: Number(String(x.id).split('/').pop()), handle: x.handle };
    }).filter(function (x) { return x.id && x.handle; }));
    var base = fromIds(j.ids);
    cust.version = j.version === undefined ? null : j.version;
    list = replay(base, cust.ops);
    cust.items = list;
  }
  function send(tries) {
    tries = tries || 0;
    if (!cust || !cust.ops.length) return;
    if (inFlight) { again = true; return; }
    inFlight = true; again = false;
    var step = cust.version === undefined
      ? api('GET').then(function (j) { if (j.status !== 200) throw j; adopt(j); })
      : Promise.resolve();
    var nOps = 0;
    step.then(function () {
      nOps = cust.ops.length;
      return api('POST', { ids: list.map(function (x) { return 'gid://shopify/Product/' + x.id; }), base_version: cust.version });
    }).then(function (j) {
      if (j.status === 200) {
        cust.version = j.version === undefined ? null : j.version;
        cust.ops = cust.ops.slice(nOps);
        cust.ts = Date.now();
        if (cust.ops.length) again = true;
      } else if (j.status === 409 && tries < 3) {
        adopt(j);
        again = true; tries++;
      } else {
        throw j;
      }
      saveCust();
      paint(document);
    }).catch(function () { again = false; /* ops stay, retried on next load */ })
      .then(function () { inFlight = false; if (again) send(tries); });
  }

  function toggle(id, handle) {
    var op;
    id = Number(id);
    if (has(id)) {
      list = list.filter(function (x) { return x.id !== id; });
      op = { t: '-', id: id };
    } else {
      if (list.length >= MAX) {
        window.alert('Legfeljebb ' + MAX + ' kedvencet tudunk megőrizni. Ha újat adnál hozzá, előbb vegyél ki egyet a Kedvenceim oldalon.');
        return;
      }
      list.unshift({ id: id, handle: handle || '' });
      known[id] = handle || known[id] || '';
      op = { t: '+', id: id, handle: handle || '' };
    }
    persist(op);
    paint(document);
    document.dispatchEvent(new CustomEvent('nutrio:kedvencek', { detail: { count: list.length } }));
  }

  // Writes only what changed: an unconditional textContent write is itself a childList mutation,
  // and with the observer below it would repaint the page forever (ChatGPT review, 2026-10-16).
  function setText(el, t) { if (el.textContent !== t) el.textContent = t; }
  function setAttr(el, k, v) { if (el.getAttribute(k) !== v) el.setAttribute(k, v); }
  function paintButton(b) {
    var on = has(b.getAttribute('data-kedvenc-id'));
    if (b.classList.contains('is-active') !== on) b.classList.toggle('is-active', on);
    setAttr(b, 'aria-pressed', on ? 'true' : 'false');
    setAttr(b, 'aria-label', (on ? 'Kivétel a kedvencek közül: ' : 'Kedvencekhez adás: ') + (b.getAttribute('data-kedvenc-nev') || ''));
    var t = b.querySelector('.nutrio-kedvenc__felirat');
    if (t) setText(t, on ? 'Mentve a kedvenceid közé' : 'Kedvencek közé');
  }
  function paint(root) {
    (root && root.querySelectorAll ? root : document).querySelectorAll('[data-kedvenc-id]').forEach(paintButton);
    document.querySelectorAll('[data-kedvenc-count]').forEach(function (el) {
      setText(el, list.length > 99 ? '99+' : String(list.length));
      if (el.hidden !== (list.length === 0)) el.hidden = list.length === 0;
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kedvenc-id]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(b.getAttribute('data-kedvenc-id'), b.getAttribute('data-kedvenc-handle'));
  }, true);

  // Cards arrive later too (filters, infinite scroll, recommendations, quick view).
  // Only newly added nodes that carry (or contain) a heart are painted, nothing else is touched.
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.hasAttribute('data-kedvenc-id')) paintButton(n);
        else if (n.querySelector('[data-kedvenc-id]')) n.querySelectorAll('[data-kedvenc-id]').forEach(paintButton);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Another tab changed the list: follow it.
  window.addEventListener('storage', function (e) {
    if (e.key === GUEST_KEY || e.key === CUST_KEY) { load(); paint(document); }
  });
  // iOS Safari back/forward cache restores the old page with old memory: re-read the stored list.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { load(); paint(document); }
  });

  /* ---------- "Kedvenceim" list page ---------- */
  function money(cents) {
    // Shop format is "3.190 Ft" (toLocaleString('hu-HU') would give "3190 Ft" below 10 000).
    return String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' Ft';
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function img(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') < 0 ? '?' : '&') + 'width=400';
  }

  function renderPage(box) {
    var grid = box.querySelector('[data-kedvenc-racs]');
    var empty = box.querySelector('[data-kedvenc-ures]');
    var guestNote = box.querySelector('[data-kedvenc-vendeg]');
    if (guestNote) guestNote.hidden = !!cfg.loggedIn;
    if (!list.length) { grid.innerHTML = ''; empty.hidden = false; return; }
    empty.hidden = true;
    grid.setAttribute('aria-busy', 'true');
    // Results are keyed by product id, so a list change during loading cannot pair a product
    // with the wrong entry. Only a 404 counts as "gone"; network errors keep the entry.
    var snapshot = list.slice();
    Promise.all(snapshot.map(function (x) {
      if (!x.handle) return Promise.resolve({ id: x.id, gone: true });
      return fetch('/products/' + encodeURIComponent(x.handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) {
          if (r.status === 404) return { id: x.id, gone: true };
          if (!r.ok) return { id: x.id, err: true };
          return r.json().then(function (p) { return { id: x.id, p: p }; }, function () { return { id: x.id, err: true }; });
        })
        .catch(function () { return { id: x.id, err: true }; });
    })).then(function (res) {
      grid.removeAttribute('aria-busy');
      var failed = 0;
      var html = res.map(function (r) {
        if (r.err) failed++;
        if (!r.p || !has(r.id)) return '';
        var p = r.p;
        var single = p.variants.length === 1;
        var v = p.variants.filter(function (x) { return x.available; })[0];
        var btn;
        if (!p.available) {
          btn = '<span class="nutrio-kl__elfogyott">Jelenleg nem kapható</span>';
        } else if (single && v) {
          btn = '<button type="button" class="button button-primary nutrio-kl__kosar" data-kosar-variant="' + v.id + '">Kosárba rakás</button>';
        } else {
          btn = '<a class="button button-primary nutrio-kl__kosar" href="' + esc(p.url) + '">Kiválasztom</a>';
        }
        return '<li class="nutrio-kl__kartya">' +
          '<button type="button" class="nutrio-kedvenc nutrio-kedvenc--lista" data-kedvenc-id="' + p.id + '" data-kedvenc-handle="' + esc(p.handle) + '" data-kedvenc-nev="' + esc(p.title) + '" aria-pressed="true">' + HEART + '</button>' +
          '<a class="nutrio-kl__kep" href="' + esc(p.url) + '">' + (p.featured_image ? '<img src="' + esc(img(p.featured_image)) + '" alt="' + esc(p.title) + '" loading="lazy" width="400" height="400">' : '') + '</a>' +
          '<a class="nutrio-kl__nev" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<div class="nutrio-kl__ar">' + (p.price_varies ? 'már ' : '') +
            (p.compare_at_price > p.price ? '<span class="nutrio-kl__akcios">' + money(p.price) + '</span> <s>' + money(p.compare_at_price) + '</s>' : money(p.price)) + '</div>' +
          btn + '</li>';
      }).join('');
      grid.innerHTML = html + (failed ? '<li class="nutrio-kl__hiba">' + failed + ' kedvencedet most nem sikerült betölteni. <a href="" class="underline">Frissítsd az oldalt</a>.</li>' : '');
      // Deleted or unpublished products (404): drop them from the list.
      var gone = {};
      res.forEach(function (r) { if (r.gone) gone[r.id] = 1; });
      if (Object.keys(gone).length) {
        list = list.filter(function (x) { return !gone[x.id]; });
        Object.keys(gone).forEach(function (id) { if (cust) cust.ops.push({ t: '-', id: Number(id) }); });
        persist();
        paint(document);
      }
      if (!list.length) empty.hidden = false;
      paint(box);
    });
  }

  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></svg>';

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kosar-variant]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-kosar-variant')), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error();
      b.textContent = 'Kosárban ✓';
      // The add succeeded; a failed counter refresh must not invite a second add.
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        document.querySelectorAll('.cart-bubble__container').forEach(function (el) {
          el.setAttribute('data-count-item', c.item_count);
          el.innerHTML = '<span class="h-full flex items-center justify-center" aria-hidden="true">' + (c.item_count < 100 ? c.item_count : '99+') + '</span>';
        });
      }).catch(function () {});
    }, function () {
      b.disabled = false;
      b.textContent = 'Nem sikerült, próbáld újra';
    });
  });

  function start() {
    paint(document);
    var box = document.querySelector('[data-kedvenc-oldal]');
    if (box) {
      renderPage(box);
      document.addEventListener('nutrio:kedvencek', function () {
        // On the list page a removed heart removes the tile.
        box.querySelectorAll('.nutrio-kl__kartya').forEach(function (li) {
          var b = li.querySelector('[data-kedvenc-id]');
          if (b && !has(b.getAttribute('data-kedvenc-id'))) li.remove();
        });
        if (!list.length) box.querySelector('[data-kedvenc-ures]').hidden = false;
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  window.NutrioKedvencek = cfg;
  cfg.api = { list: function () { return list.slice(); }, toggle: toggle, has: has };
})();
